import { useUser } from "capsule"

import { oneDayMillis } from "../config/Constants"
import { useConfig } from "./useConfig"
import currentDateMs from "./useDateMock"

export const useIsPasswordExpired = () => {
  const { userData } = useUser()
  const config = useConfig()

  const isPasswordExpired =
    userData &&
    (!userData.passwordLastChangedAt ||
      currentDateMs() - userData.passwordLastChangedAt >
        (config?.passwordLifeTimeInDays ?? 90) * oneDayMillis)

  return isPasswordExpired
}
